import { React, useState } from "react";

import { SimpleForm, useNotify, useRefresh, useDataProvider, Button, Toolbar } from "react-admin";

import { Dialog, DialogTitle, Typography, Box } from "@mui/material";

import DeleteIcon from "@mui/icons-material/Delete";
import CancelIcon from "@mui/icons-material/Cancel";

const DeleteToolbar = ({ onCancel, onDelete }) => {
  return (
    <Toolbar>
      <Box sx={{ flex: 1, display: "flex", justifyContent: "space-between" }}>
        <Button
          variant="contained"
          sx={{ padding: "6px", fontSize: "0.875rem" }}
          label="Потвърди"
          onClick={onDelete}
        >
          <DeleteIcon />
        </Button>
        <Button
          sx={{ padding: "6px", fontSize: "0.875rem" }}
          label="Откажи"
          onClick={onCancel}
        >
          <CancelIcon />
        </Button>
      </Box>
    </Toolbar>
  );
};

const DeleteVersion = ({ record, resource }) => {
  const refresh = useRefresh();
  const notify = useNotify();
  const dataProvider = useDataProvider();

  const [isOpen, setIsOpen] = useState(false);

  const onDelete = () => {
    return dataProvider
      .delete(resource, {
        id: record.id,
        meta: { useFormData: false },
      })
      .then(() => {
        notify("Версията е изтрита успешно!", { type: "success" });
        refresh();
        setIsOpen(false);
      })
      .catch(error => {
        notify("Версията не е изтрита!", { type: "error" });
        refresh();
        setIsOpen(false);
      });
  };

  return (
    <>
      <Button
        label="Изтрий"
        onClick={() => {
          setIsOpen(true);
        }}
      >
        <DeleteIcon />
      </Button>
      <Dialog
        fullWidth
        maxWidth="md"
        open={isOpen}
      >
        <DialogTitle>{`Изтрий версия с ID: ${record.id}`}</DialogTitle>
        <SimpleForm
          toolbar={
            <DeleteToolbar
              onCancel={() => setIsOpen(false)}
              onDelete={() => onDelete()}
            />
          }
        >
          <Typography>Сигурен ли сте, че искате да изтриете тази версия?</Typography>
        </SimpleForm>
      </Dialog>
    </>
  );
};

export default DeleteVersion;
